<template>
  <div class="report-container">
    <h1>Reports Dashboard</h1>
    
    <div class="table-container">
      <table class="report-table">
        <thead>
          <tr>
            <th class="left-align">Report Name</th>
            <th class="right-align">View Report</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="left-align">Profit & Loss Report</td>
            <td class="right-align"><router-link to="/reports/profit-loss" class="report-link">View</router-link></td>
          </tr>
          <tr>
            <td class="left-align">Inventory Value Report</td>
            <td class="right-align"><router-link to="/reports/inventory-value" class="report-link">View</router-link></td>
          </tr>
          <tr>
            <td class="left-align">Sales Analysis Report</td>
            <td class="right-align"><router-link to="/reports/sales-analysis1" class="report-link">View</router-link></td>
          </tr>
          <tr>
            <td class="left-align">Sales Channel Report</td>
            <td class="right-align"><router-link to="/reports/sales-channel" class="report-link">View</router-link></td>
          </tr>
          <tr>
            <td class="left-align">Buyer Report</td>
            <td class="right-align"><router-link to="/reports/buyer" class="report-link">View</router-link></td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
.report-container {
  padding: 20px;
  font-family: "Poppins", sans-serif !important;
  background: #9cd0f2;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.table-container {
  background: #eef4fb;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.report-table th, .report-table td {
  border: 1px solid #83a7cb;
  padding: 12px;
}

.report-table th {
  background: #e6eef3;
  text-align: left;
}

.report-table tr:hover {
  background-color: #e0f2f1;
}

.left-align {
  text-align: left;
}

.right-align {
  text-align: right;
}

.report-link {
  text-decoration: none;
  color: #327ba8;
  font-weight: bold;
}

.report-link:hover {
  color: #286c98;
}
</style>